/**
 * @description 提供根据URL参数进行跳转的服务
 * @author haowei@sohu-inc.com
 */

import Helper from './helper.js'

let _queryObj = Helper.urlToObj(window.location.href)

/**
 * @description 根据url参数中的search参数进行跳转的服务
 * @param { string } queryName 代表参数的名称，值为要跳转到的相应的链接经过encodeURIComponent编码，可由业务放进行灵活定义其规范和意义
 * @param { object } event 代表原生事件，需要阻止原生事件时再传入即可
 */

export default function(queryName, event){
    if(queryName && _queryObj[queryName]) {
        if(event && event.preventDefault && typeof event.preventDefault === 'function') event.preventDefault()
        window.location.href = decodeURIComponent(_queryObj[queryName])
        return true
    }
    return false
}